// Role and permission codes (data-model.md 4.2 and 12.2, REQ-12.1, REQ-12.5).
// Each permission is checked in code, so a new permission ships with the code that checks it.

//
// poc CT-008 (module-2 Section 3): two groups, Admins and Editors. Every Editor and Admin holds the app role
// `owner` in every app (shown as "Editor"); `platform_admin` is shown as "Admin". No one is given `engineer`
// any more: it stays only because published workflow versions are immutable and their transition and
// protected-move role limits name it (TRANSITION_ROLE_CODES). `viewer` is retired (migration 0008 deletes it).
export const TOOL_ROLE_CODES = ['reporter', 'staff_member', 'platform_admin'] as const;
export const APP_ROLE_CODES = ['owner', 'engineer'] as const;
export const ROLE_CODES = [...TOOL_ROLE_CODES, ...APP_ROLE_CODES] as const;
export type RoleCode = (typeof ROLE_CODES)[number];
export type AppRoleCode = (typeof APP_ROLE_CODES)[number];

export const PERMISSION_CODES = [
  'report.submit',
  'my_requests.view',
  'app.register',
  'mcp.connect',
  'ticket.view',
  'ticket.comment',
  'ticket.attach',
  'ticket.mark_fixed',
  'ticket.move_fixed_back',
  'ticket.decide',
  'ticket.prioritise',
  'ticket.assign',
  'ticket.override_ai',
  'ticket.merge_unlink',
  'ticket.move_back',
  'dashboard.view',
  'app.manage_settings',
  'app.manage_masking',
  'oversight.view',
  'oversight.score',
  'workflow.manage',
  'tool.manage_settings',
  'tool.manage_groups',
  'data.delete',
  'data.export_person',
] as const;
export type PermissionCode = (typeof PERMISSION_CODES)[number];
